import { useForm } from 'react-hook-form';

import { OpstartSolverOpdracht } from '@/queries/mutaties/opdrachten';
import { useSolver } from '@/queries/mutaties/useSolver';

export type OpstartSolverInputs = {
  dienstregelpunten: Array<string>;
  materieelTypes: Array<string>;
  opstartDatum: string;
};

const useOpstartSolver = (handleOpenChange: (open: boolean) => void) => {
  const { startenOpstartSolver } = useSolver();
  const { handleSubmit, reset, control, setValue } = useForm<OpstartSolverInputs>({
    mode: 'onSubmit',
  });

  const resetDialog = () => {
    handleOpenChange(false);
    reset();
  };

  function createOpdracht(target: OpstartSolverInputs) {
    const opstartSolverOpdracht: OpstartSolverOpdracht = {
      materieelTypes: target.materieelTypes.map((v) => {
        const lastDash = v.lastIndexOf('-');
        return {
          soort: lastDash !== -1 ? v.substring(0, lastDash) : v,
          aanduiding: lastDash !== -1 ? v.substring(lastDash + 1) : v,
        };
      }),
      dienstregelpunten: target.dienstregelpunten.length == 0 ? ['*'] : target.dienstregelpunten.map((v) => v.trim()),
      opstartDatum: target.opstartDatum,
    };
    return opstartSolverOpdracht;
  }

  const onSubmit = async (target: OpstartSolverInputs) => {
    const opdracht = createOpdracht(target);
    return await (async () => {
      console.log(opdracht);
      return await startenOpstartSolver(opdracht);
    })();
  };

  return {
    onSubmit,
    resetDialog,
    control,
    handleSubmit,
    setValue,
  };
};
export default useOpstartSolver;
